
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3195c400&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./storeReviews.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./storeReviews.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3195c400!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./storeReviews.vue"),
  /* scopeId */
  "data-v-3195c400",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/contentManagement/storeReviews.vue
// module id = 1507
// module chunks = 3